import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const PriceCatalogLink = () => {

  return (
    <AsideMenuLink
      pathname={P.PRICE_CATALOG_PAGE}
      subject={S.PRICE_CATALOG_PAGE}
      icon={'Price-catalog_light_green.svg'}
      label={<FormattedMessage id="price-catalog-page-link" defaultMessage="Price catalog"/>}
      isSubSection={false}
    />
  );
};

export default PriceCatalogLink;
